class ProductDetailReviews extends Component {
    /** @var {HTMLDivElement} */
    writeReviewSectionElement;
    /** @var {HTMLFormElement} */
    form;

    constructor(el) {
        super(el);
        this.loginBtn = this.$find('[data-login]');
        this.writeReviewSectionElement = this.$el.querySelector("[data-reviews-new]");
        this.form = this.$el.querySelector(`form[id="productReview-add"]`);
        if (!this.form) {
            console.error("Nepodařilo se najít formulář!");
            return;
        }

        if (this.form.dataset.isInvalid) {
            this.showForm();
        }

        this.addEventListeners();
    }

    showForm() {
        this.writeReviewSectionElement.classList.remove("u-hiddenVisually");
        const buttons = this.$el.querySelectorAll("[data-show-product-form-button]");
        buttons.forEach((value, key) => {
            value.classList.add("u-hiddenVisually");
        });
    }

    addEventListeners() {
        this.loginBtn && this.loginBtn.addEventListener('click', e => {
            e.preventDefault();
            EventBus.getInstance().dispatchEvent('showBasePopup', 'login-popup');
        });

        const buttons = this.$el.querySelectorAll("[data-show-product-form-button]");
        buttons && buttons.forEach((value, key) => {
            value.addEventListener("click", () => {
                this.showForm();
            });
        });
    }
}